import * as yup from 'yup'

const schema = yup.object().shape({
  idAnimal: yup.string().required('Selecione a vaca'),
  dataDiagnostico: yup.string().nullable(),
  tipoReproducao: yup.string().required('Selecione o tipo de reprodução'),
  touro: yup.string().required('Selecione o touro'),
  diagnostico: yup.string().required('Selecione o diagnóstico')
})

export default schema
